import { InboxIcon } from '@heroicons/react/24/outline';
import { type ComponentType, type SVGProps } from 'react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  description?: string;
  action?: ReactNode;
  /**
   * KÁRTYÁN BELÜL: behúzás, hogy a szaggatott keret ne érjen a kártya SZÉLÉHEZ (a `PanelCard` törzse
   * szándékosan `p-0`, mert a sor-listák teljes szélességűek). Enélkül a szaggatott box a kártya-kerethez
   * tapadt, és a kettő „dupla keretnek" látszott — a user pontosan ezt mérte a partner-kezdőlap
   * üzenet-kártyáján. Teljes lapon/táblán NEM kell (ott a lap-padding adja a levegőt).
   */
  inset?: boolean;
  className?: string;
}

/** Egységes „nincs adat" állapot (lista/keresés üres eredménye) — a régi CRM table-no-data modern megfelelője. */
export function EmptyState({
  icon: Icon = InboxIcon,
  title,
  description,
  action,
  inset = false,
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-dashed p-10 text-center',
        // `flex-1`: ha a szülő törzs flex-oszlop (`PanelCard fill`), a keret a kártya aljáig nyúlik, tehát a
        // térköz MIND A NÉGY oldalon ugyanannyi. Nem-flex szülőben a `flex-1` hatástalan.
        inset && 'm-3 flex-1',
        className,
      )}
    >
      <span className="bg-sunken text-muted-foreground mb-3 inline-flex size-11 items-center justify-center rounded-xl border">
        <Icon className="size-5" />
      </span>
      <p className="text-base font-semibold">{title}</p>
      {description && <p className="text-md text-muted-foreground mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
